__turbopack_context__.v({
  "backHomeBtn": "index-module-scss-module__GUwc4G__backHomeBtn",
  "container": "index-module-scss-module__GUwc4G__container",
  "errorDesc": "index-module-scss-module__GUwc4G__errorDesc",
  "errorTitle": "index-module-scss-module__GUwc4G__errorTitle",
});
